import { render } from "./character_row.vue?vue&type=template&id=5b0b29c6&lang=pug"
import script from "./character_row.vue?vue&type=script&lang=js"
export * from "./character_row.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../../../node/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__